import { motion } from "framer-motion";
import "./footer.scss";

const Footer: React.FC = () => {
  // Container variant for staggering children
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15, // 0.15s between each child
      },
    },
  };

  // Item variant for fade + slide up
  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <div
      className="contain-wrapper footer"
      style={{ backgroundImage: "url('/images/footerbg.jpg')" }}
    >
      {/* Contact Row */}
      <motion.div
        className="grid contain grid-bottom"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.div className="col-3 footertitle firstcol" variants={itemVariants}>
          Contact
        </motion.div>
        <motion.div className="col-9" variants={itemVariants}>
          <p>For further information please contact our joint agents:</p>
        </motion.div>
      </motion.div>

      {/* Bluebook Agents */}
      <motion.div
        className="grid contain"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.div className="col-3 firstcol" variants={itemVariants}>
          <a href="https://bluebooklondon.com/" target="_blank" rel="noreferrer">
            <img src="../images/bluebook.svg" alt="Bluebook logo" />
          </a>
        </motion.div>
        <motion.div className="col-3" variants={itemVariants}>
          <p>
            <span className="caps">Isobel Ewart-Fearn</span>
            <br />
            <a href="tel:+447714491025">+44 (0)7714 491 025</a>
            <br />
            <a href="mailto:isobel@bluebooklondon.com">isobel@bluebooklondon.com</a>
          </p>
        </motion.div>
        <motion.div className="col-3" variants={itemVariants}>
          <p>
            <span className="caps">Tor Cuming</span>
            <br />
            <a href="tel:+447714089823">+44 (0)7714 089 823</a>
            <br />
            <a href="mailto:tor@bluebooklondon.co.uk">tor@bluebooklondon.co.uk</a>
          </p>
        </motion.div>
        
      </motion.div>

      {/* CBRE Agents */}
      <motion.div
        className="grid contain"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.div className="col-3 firstcol" variants={itemVariants}>
          <a href="https://www.cbre.co.uk/" target="_blank" rel="noreferrer">
            <img src="../images/cbre.svg" alt="CBRE logo" />
          </a>
        </motion.div>
        <motion.div className="col-3" variants={itemVariants}>
          <p>
            <span className="caps">Matt Chicken</span>
            <br />
            <a href="tel:+447852205099">+44 (0)7852 205 099</a>
            <br />
            <a href="mailto:matt.chicken@cbre.com">matt.chicken@cbre.com</a>
          </p>
        </motion.div>
        <motion.div className="col-3" variants={itemVariants}>
          <p>
            <span className="caps">Georgina Willoughby</span>
            <br />
            <a href="tel:+447788706031">+44 (0)7788 706 031</a>
            <br />
            <a href="mailto:georgina.willoughby@cbre.com">georgina.willoughby@cbre.com</a>
          </p>
        </motion.div>
      </motion.div>

      {/* Lines and Footer Info */}
      <motion.div
        className="grid contain halfgap"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.div className="col-3 linespace" variants={itemVariants}></motion.div>
        <motion.div className="col-9" variants={itemVariants}>
          <div className="line"></div>
        </motion.div>
      </motion.div>

      <motion.div
        className="grid grid-middle contain halfgap"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.div className="col-3 firstcol" variants={itemVariants}>
          <p>A development by</p>
        </motion.div>
        <motion.div className="col-3 lazaricol" variants={itemVariants}>
          <a href="https://lazari.co.uk/" target="_blank" rel="noreferrer">
            <img src="../images/lazari.svg" alt="Lazari logo" />
          </a>
        </motion.div>
        <motion.div className="col-3 lazaricol" variants={itemVariants}>
          <p>
            <a href="https://lazari.co.uk/" target="_blank" rel="noreferrer">
              Lazari.co.uk
            </a>
          </p>
        </motion.div>
      </motion.div>

      <motion.div
        className="grid contain"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.div className="col-3 linespace" variants={itemVariants}></motion.div>
        <motion.div className="col-9" variants={itemVariants}>
          <div className="line"></div>
        </motion.div>
      </motion.div>

      {/* Bottom Footer Text */}
      <motion.div
        className="grid grid-bottom contain misrep"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.div className="col-3 firstcol" variants={itemVariants}>
          <p>©28 St George Street. 2025.</p>
        </motion.div>
        <motion.div className="col-9" variants={itemVariants}>
          <p>
            Misrepresentation Act 1967: Bluebook and CBRE for themselves and for the
            vendor(s) or lessor(s) of this property whose agents they are, give notice
            that: 1. These particulars do not constitute, nor constitute any part of, an
            offer or contract. 2. None of the statements contained in these particulars
            as to the property are to be relied on as statements or representations of
            fact. 3. Any intending purchaser or lessee must satisfy himself by
            inspection or otherwise as to the correctness of each of the statements
            contained in these particulars. 4. The vendor(s) or lessor(s) do not make
            or give Bluebook, CBRE, nor any person in their employment has any
            authority to make or give, any representation or warranty whatever in
            relation to this property. Finance Act 2013: Unless otherwise stated all
            prices and rents are quoted exclusive of VAT. The Business Protection from
            Misleading Marketing Regulations 2008: These details are believed to be
            correct at the time of compilation but may be subject to subsequent&nbsp;amendment.
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Footer;
